module.exports = __webpack_public_path__ + "static/media/slider-1.ab1327ea.jpg";